import React from 'react'
import { Typography, Card, CardContent, Container, Box, Button, ButtonGroup, SelectChangeEvent } from '@mui/material'

import { usePermission } from '../components/auth'

import { TimesheetReportCard } from '../components/timesheets'

export function TimesheetUtilisationSummary() {
  const { roleSlug } = usePermission()
  const canSeePerformance = roleSlug == 'ROLE_ADMIN' || roleSlug == 'ROLE_MANAGER'

  return (
    <>
      <Container maxWidth="xl">
        <TimesheetReportCard reportType="utilisation" />

        {canSeePerformance ? <TimesheetReportCard reportType="performance" /> : <></>}
      </Container>
    </>
  )
}
/*

*/
